/** Use an available source without overwriting the user's preferred source. */
export function resolveScreenerPriceExchange(preferred: string, available: string[]): string {
  if (preferred && available.includes(preferred)) return preferred
  return available.includes('binance') ? 'binance' : available[0] || ''
}
